(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/lyckoplatsen/map-shared/map-assets.js') >= 0) return;  svs.modules.push('/components/tur/lyckoplatsen/map-shared/map-assets.js');

'use strict';

const tileLayerUrl = "".concat(svs.lyckoplatsen.data.config.mapLocation, "/tile/{z}/{x}/{y}.png?token=").concat(svs.lyckoplatsen.data.config.jwt);
const pinPath = "M0.333374 26.764C0.333374 11.5017 11.8379 0 27 0V0.00415163C42.0584 0.00415163 53.6667 11.5059 \n53.6667 26.7681C53.6667 33.1188 51.2963 38.0362 48.2196 43.2673C45.143 48.4985 27 80 27 80C27 80 8.61371 \n47.9645 5.69745 43.1968C2.78119 38.429 0.333374 33.0855 0.333374 26.764ZM10.7487 22.9781C10.7487 18.5127 \n14.4089 14.9257 18.8743 14.9257C23.3398 14.9257 27 19.7938 27 19.7938C27 19.7938 30.6602 14.9257 35.1257 \n14.9257C39.6278 14.9257 43.2514 18.5493 43.2514 22.9781C43.2514 26.5652 41.8239 35.0934 27.8053 43.7316C27.5491 \n43.878 26.9635 44.244 26.9635 44.244C26.9635 44.244 26.3778 43.878 26.1216 43.7316C12.1761 35.0934 10.7487 \n26.5652 10.7487 22.9781Z";
const colorMap = {
  blue: '#2073E5',
  lp: '#2073E5',
  midBlue: '#1047B8',
  'lp-100': '#1047B8',
  darkBlue: '#001E3C',
  'lp-200': '#001E3C',
  green: '#16FFAB',
  'lp-300': '#16FFAB',
  red: '#FF5D39',
  'lp-400': '#FF5D39',
  lightBlue: '#DDECFF',
  'lp-500': '#DDECFF',
  lightGreen: '#D5FFF0',
  'lp-600': '#D5FFF0',
  white: '#FFFFFF',
  black: '#000000'
};
const isHexColor = str => /^#([0-9A-F]{3}){1,2}$/i.test(str);
const getColor = color => isHexColor(color) ? color : colorMap[color] || colorMap.lp;
const getPinIconHtml = function () {
  let {
    color = 'blue',
    useSmallIcon = false
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const finalColor = getColor(color);
  return "<svg \n            xmlns=\"http://www.w3.org/2000/svg\" \n            width=\"".concat(useSmallIcon ? 30 : 54, "\" \n            height=\"").concat(useSmallIcon ? 44 : 80, "\" \n            viewBox=\"0 0 54 80\" \n            fill=\"none\"\n            preserveAspectRatio=\"none\">\n            <path\n              fill-rule=\"evenodd\" \n              clip-rule=\"evenodd\" \n              d=\"").concat(pinPath, "\" \n              fill=\"").concat(finalColor, "\"\n            />\n          </svg>");
};
const getIconLeaflet = function () {
  let {
    color = 'blue',
    className = '',
    useSmallIcon,
    count = 0
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (useSmallIcon) {
    className += ' icon-small';
  }
  const leafletDivIcion = leaflet.divIcon({
    className: "".concat(className, " pin-heart "),
    html: getPinIconHtml({
      color,
      useSmallIcon
    }),
    renderer: leaflet.svg({
      padding: 0.85
    }),
    iconSize: useSmallIcon ? [30, 44] : [54, 80],
    iconAnchor: useSmallIcon ? [15, 44] : [27, 80]
  });
  if (count > 0) {
    leafletDivIcion.options.html = "<div class=\"pin-heart-count gsap-heart-count\" style=\"background-color: ".concat(getColor(color), "\">").concat(count, "</div>").concat(leafletDivIcion.options.html);
  }
  return leafletDivIcion;
};
Object.assign(svs.tur.lyckoplatsen.map, {
  tileLayerUrl,
  pinPath,
  getPinIconHtml,
  getIconLeaflet,
  getColor
});

 })(window);